import Firebase from '../lib/Firebase';

/**
 * Service for storing images on firebase storage
 * @param  {Object} file The image file to be stored
 * @return {Promise} A promise which resolves with image url where it is stored, or an error
 */
export default function(file, collection, fileName) {
  return new Promise(resolve => {
    const storageRef = Firebase.storage()
      .ref()
      .child(`${collection}/${fileName}`);

    const task = storageRef.put(file);

    task.on('state_changed', null, null, () => {
      const imageObject = {
        imageUrl: task.snapshot.downloadURL
      };

      Firebase.firestore()
        .collection(collection)
        .doc(fileName)
        .update(imageObject)
        .then(resolve(task.snapshot.downloadURL));
    });
  });
}



// WEBPACK FOOTER //
// ./src/lib/UploadService.js